import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Opening a new page (product, category page, etc.) starts at the top.
// Back/forward keeps the browser's remembered scroll position.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    if (navType !== "POP") window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, navType]);
  return null;
}
